// extracted by mini-css-extract-plugin
module.exports = {"goodInfo":"style_goodInfo__2IQ7H","offersContainer":"style_offersContainer__1bcWE"};